function configuratorAddToCart() {
  $("span.ajax_to_cart").on("click", function (event) {
    event.preventDefault();
    //$(event.target).text("Adding...");

    let productSku = $('body .ProductForm__Option select[name=id] option:selected').attr('data-sku');
    const skuArray = productSku.split("-");
    let modelType = skuArray[1];
    console.log(modelType);
    
    if (modelType == "SCO" && 1 == 2) {
      let flitecellType = productSku.slice(-2);
      if (flitecellType == "SP") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Sport Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }
      if (flitecellType == "EX") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Explore Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }      
    }

    if (modelType == "MN60" || modelType == "MN86") {
      let flitecellType = productSku.slice(-2);
      let wingType = skuArray[4];
      let driveType = skuArray[3];

      // MN60 Wave Nano 
      if (flitecellType == "NA" && wingType == "CJ15C") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Cruiser Jet 1500 C / MN Nano Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }
      if (flitecellType == "NA" && wingType == "MN13C") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("MN 1300 C / MN Nano Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }      
      if (flitecellType == "NA" && wingType == "FS13C") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Flow S 1300 C / MN Nano Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }      
      if (flitecellType == "NA" && wingType == "FW11C") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Flow 1100 C / MN Nano Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }      
      if (flitecellType == "NA" && wingType == "W1000C") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Wave 1000 C / MN Nano Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }
      if (flitecellType == "NA" && wingType == "FW90C") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Flow 900 C / MN Nano Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }
      if (flitecellType == "NA" && wingType == "W850C") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Wave 850 C / MN Nano Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }

      // MN60 or MN86 Nano
      if (flitecellType == "NA" && driveType == "JTG") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Cruiser Jet 1500 C - MN 1300 C / MN Nano Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }
      
      // MN60 Wave Sport
      if (flitecellType == "SP" && wingType == "CJ15C") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Cruiser Jet 1500 C / MN Sport Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }
      if (flitecellType == "SP" && wingType == "MN13C") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("MN 1300 C / MN Sport Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }      
      if (flitecellType == "SP" && wingType == "FS13C") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Flow S 1300 C / MN Sport Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }      
      if (flitecellType == "SP" && wingType == "FW11C") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Flow 1100 C / MN Sport Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }      
      if (flitecellType == "SP" && wingType == "W1000C") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Wave 1000 C / MN Sport Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }
      if (flitecellType == "SP" && wingType == "FW90C") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Flow 900 C / MN Sport Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }
      if (flitecellType == "SP" && wingType == "W850C") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Wave 850 C / MN Sport Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }

      // MN60 or MN86 Sport
      if (flitecellType == "SP" && driveType == "JTG") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("Cruiser Jet 1500 C - MN 1300 C / MN Sport Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }

      // MN60 or MN86 Explore
      if (flitecellType == "EX") {
        let preorderVariant = $('body .ProductForm__Option select[name=id] option:contains("MN Explore Preorder")').val();
        $('body .ProductForm__Option select[name=id]').val(preorderVariant);
      }
      var selectedVariants = $("body .ProductForm__Option select[name=id], body #summaryBattery div.SummaryBlock, body #summaryCharger div.SummaryBlock, body #summaryMNController div.SummaryBlock, input.enhancement");
    } else {
      var selectedVariants = $("body .ProductForm__Option select[name=id], body #summaryBattery div.SummaryBlock, body #summaryCharger div.SummaryBlock, body #summaryController div.SummaryBlock, input.enhancement");
    }

   var selectedFormData = $.map(selectedVariants, function (obj) {
      var extractedId = $(obj).val() || $(obj).attr("value") || $(obj).attr("data-option-id");

      return extractedId
        ? {
            id: extractedId,
            quantity: 1,
            properties: { _config: Date.now().toFixed(0) },
          }
        : null;
    });
    let formData = {
      items: selectedFormData,
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json().then((data) => {
          if (!response.ok) {
            const message = typeof data.description === "string" ? data.description
              : typeof data.message === "string" ? data.message : "Unable to add this setup to the cart.";
            throw new Error(message);
          }
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: 0,
              quantity: 0
            }
          }));
          return data;
        });
      })
      .catch((error) => {
        $(event.target).text("Error." + error.message);
        console.error("Error:", error);
      });
  });
}

configuratorAddToCart();

class configuratorAddToCartComponent extends HTMLElement {
  constructor() {
    super();
    this.productsToAdd = {};
    this.someButton = this.querySelector("button");
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    this.addToCart();
  }

  selectedVariants() {
    let productSku = $('body .ProductForm__Option select[name=id] option:selected').attr('data-sku');
    const skuArray = productSku.split("-");
    let modelType = skuArray[1];

    if (modelType == "MN60" || modelType == "MN86") {
      $(
        "body select[name=id], body #summaryEnhancements div.enhancement"
      );
    } else {
      $(
        "body select[name=id], body #summaryCharger div, body #summaryController div, body #summaryEnhancements div.enhancement"
      );
    }
  }

  selectedFormData() {
    $.map(this.selectedVariants, function (obj) {
      return $(obj).val()
        ? { id: $(obj).val(), quantity: 1 }
        : $(obj).attr("value")
        ? { id: $(obj).attr("value"), quantity: 1 }
        : null;
    });
  }

  addToCart() {
    // alert("C-A-T-C.js 81");
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.formData),
    })
      .then((response) => {
        this.someButton.text("Added.");
        // $(".share_or_buy").append(
        //   '<p>Your selections have been added. <a href="/cart">Go to cart</a>.</p>'
        // );
        // $(".still_unsure").hide();

        return response.json();
      })
      .catch((error) => {
        this.someButton.text("Error." + error.message);
        console.error("Error:", error);
      });
  }
}

customElements.define("add-to-order", configuratorAddToCartComponent);